import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatSectionHeader = createCustomElementWrapper('kat-section-header', 'KatSectionHeader', {
    'actionIcon': 'action-icon',
    'actionLabel': 'action-label',
    'statusType': 'status-type',
}, {
    'onAction': 'action',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/section-header.js
// module id = 1254
// module chunks = 0